var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.5 10.5V7.49999C1.5 7.30108 1.57902 7.11031 1.71967 6.96966C1.86032 6.82901 2.05109 6.74999 2.25 6.74999H4.27275C4.4209 6.75003 4.56574 6.70618 4.689 6.62399L7.83375 4.52699C7.94681 4.45156 8.07823 4.40827 8.21399 4.40174C8.34974 4.39522 8.48472 4.4257 8.60449 4.48994C8.72426 4.55418 8.82432 4.64975 8.89398 4.76645C8.96365 4.88315 9.00029 5.01658 9 5.15249V12.8475C9.00002 12.9833 8.96318 13.1165 8.89341 13.233C8.82363 13.3495 8.72355 13.4448 8.60382 13.5089C8.4841 13.573 8.34924 13.6033 8.21361 13.5967C8.07799 13.5901 7.9467 13.5469 7.83375 13.4715L4.689 11.3752C4.56566 11.2933 4.42082 11.2497 4.27275 11.25H2.25C2.05109 11.25 1.86032 11.171 1.71967 11.0303C1.57902 10.8897 1.5 10.6989 1.5 10.5Z",
    stroke: "#E8E8E8",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.375 5.625C12.375 5.625 13.5 6.75 13.5 8.625C13.5 10.5 12.375 11.625 12.375 11.625M14.625 3.375C14.625 3.375 16.5 5.25 16.5 8.625C16.5 12 14.625 13.875 14.625 13.875",
    stroke: "#E8E8E8",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOn);
export default __webpack_public_path__ + "static/media/on.d8a6eede9d810268a1dc7b666fcf8855.svg";
export { ForwardRef as ReactComponent };